import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../services/firebaseAuth";
import { saveRedirectUrl } from "../utils/redirectUtils";
import { useAppSelector } from "../store";
import {
  admin,
  sessionInitialized,
} from "../features/session/sessionSlice";
import PageLoader from "./Base/PageLoader";

const AdminRoute: React.FC = () => {
  const [user, authLoading] = useAuthState(auth);
  const isAdmin = useAppSelector(admin);
  const initialized = useAppSelector(sessionInitialized);
  const location = useLocation();

  if (authLoading || !initialized) {
    return <PageLoader />;
  }

  if (!user) {
    saveRedirectUrl(location.pathname, location.search);
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
